import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      id: 1,
      image: 'https://customer-assets.emergentagent.com/job_997cb05d-ee64-432c-8b15-fa867b1343d7/artifacts/sujlk6mz_mixed%20food%20items.jpeg',
      title: 'Welcome to Adanos Burger',
      subtitle: 'Eat Fresh Stay Fresh'
    },
    {
      id: 2,
      image: 'https://customer-assets.emergentagent.com/job_997cb05d-ee64-432c-8b15-fa867b1343d7/artifacts/3tzvfp0e_half%20chicken%20.jpeg',
      title: 'Fresh Ingredients Daily',
      subtitle: 'Premium Quality You Can Taste',
      contain: true
    },
    {
      id: 3,
      image: 'https://customer-assets.emergentagent.com/job_997cb05d-ee64-432c-8b15-fa867b1343d7/artifacts/3cfht467_mixed%20food%20.jpeg',
      title: 'Visit Our Restaurant',
      subtitle: 'Cozy Atmosphere, Great Food'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative bg-black overflow-hidden">
      <div className="relative h-[600px] lg:h-[700px]">
        {/* Slides */}
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {/* Background Image */}
            <div className="absolute inset-0">
              <img
                src={slide.image}
                alt={slide.title}
                className={`w-full h-full ${slide.contain ? 'object-contain' : 'object-cover'}`}
                style={{
                  ...(slide.imagePosition ? { objectPosition: slide.imagePosition } : {}),
                  ...(slide.contain ? { backgroundColor: '#1a0a00' } : {})
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
            </div>

            {/* Content */}
            <div className="relative h-full flex items-center">
              <div className="container mx-auto px-4">
                <div className="max-w-2xl">
                  <div className="inline-block mb-4">
                    <span className="bg-red-600 text-white px-6 py-3 rounded-full text-sm font-bold uppercase tracking-wide">
                      Halal Certified
                    </span>
                  </div>
                  <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight mb-6 drop-shadow-lg">
                    {slide.title}
                  </h1>
                  <p className="text-2xl lg:text-3xl text-white/90 mb-8 drop-shadow-lg">
                    {slide.subtitle}
                  </p>
                  <div className="flex flex-wrap gap-4">
                    <Link to="/menu">
                      <Button
                        size="lg"
                        className="bg-red-600 hover:bg-red-700 text-white px-10 py-7 text-lg font-bold rounded-full transition-transform hover:scale-105 shadow-2xl"
                      >
                        VIEW MENU
                      </Button>
                    </Link>
                    <a href="tel:01618432233">
                      <Button
                        size="lg"
                        variant="outline"
                        className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-red-600 px-10 py-7 text-lg font-bold rounded-full transition-all"
                      >
                        CALL TO ORDER
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Dots */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3 z-20">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-3 rounded-full transition-all ${
                index === currentSlide
                  ? 'w-12 bg-red-600'
                  : 'w-3 bg-white/50 hover:bg-white/80'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
